import Cookies from 'js-cookie';
var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1]);
    }
  }
};

var utm_cookie = {
  'date-time': new Date(),
  utm_campaign: getUrlParameter('utm_campaign'),
  utm_source: getUrlParameter('utm_source'),
  utm_medium: getUrlParameter('utm_medium'),
  utm_content: getUrlParameter('utm_content'),
  utm_term: getUrlParameter('utm_term'),
  utm_adgroup: getUrlParameter('utm_adgroup'),
  utm_creative: getUrlParameter('utm_creative'),
  gclid: getUrlParameter('gclid'),
};

if (utm_cookie.utm_campaign !== '') {
  Cookies.set('xmatters_utm_vars', utm_cookie, { expires: 90 });
}
utm_cookie =
  typeof Cookies.get('xmatters_utm_vars') !== 'undefined'
    ? JSON.parse(Cookies.get('xmatters_utm_vars'))
    : {};

var utm_campaign =
  typeof utm_cookie.utm_campaign !== 'undefined' ? utm_cookie.utm_campaign : '';
var utm_source =
  typeof utm_cookie.utm_source !== 'undefined' ? utm_cookie.utm_source : '';
var utm_medium =
  typeof utm_cookie.utm_medium !== 'undefined' ? utm_cookie.utm_medium : '';
var utm_content =
  typeof utm_cookie.utm_content !== 'undefined' ? utm_cookie.utm_content : '';
var utm_term =
  typeof utm_cookie.utm_term !== 'undefined' ? utm_cookie.utm_term : '';
var utm_adgroup =
  typeof utm_cookie.utm_adgroup !== 'undefined' ? utm_cookie.utm_adgroup : '';
var utm_creative =
  typeof utm_cookie.utm_creative !== 'undefined' ? utm_cookie.utm_creative : '';
var gclid = typeof utm_cookie.gclid !== 'undefined' ? utm_cookie.gclid : '';
var sessionReferrer = '';

// if this is a new session
if (typeof Cookies.get('session_referrer') == 'undefined') {
  sessionReferrer = document.referrer || 'n/a';
  Cookies.set('session_referrer', sessionReferrer);
} else {
  sessionReferrer = Cookies.get('session_referrer');
}

export const getDataForMarketoForm = (data) => {
  // Marketo form expects one of the 3 values for trialRegion: Americas, EMEA, APAC
  const trialRegion = data.region === 'NA' ? 'Americas' : data.region;

  return {
    FirstName: data.firstName,
    LastName: data.lastName,
    Company: data.companyName,
    Email: data.emailAddress.toLowerCase(),
    Asset_ID__c: '7011T000001NSKjQAO',
    Email_Opt_In__c: 'yes', // this field is equivalent to 'agree terms and conditions' checkbox field
    trialRegion,
    utm_source__c: utm_source,
    utm_campaign__c: utm_campaign,
    utm_medium__c: utm_medium,
    utm_content__c: utm_content,
    utm_term__c: utm_term,
    utm_adgroup__c: utm_adgroup,
    utm_creative__c: utm_creative,
    GCLID__c: gclid, // Google Click ID
  };
};

const xmattersEmailRegex = /@xmatters.com$/i;

export const isXmattersEmail = (email) => xmattersEmailRegex.test(email);

export const trimParams = (data, list) => {
  if (!data || !list || list.length === 0) return data;
  for (const key of list) {
    let value = data[key];
    data[key] = value.trim();
  }
  return data;
};
